import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-chat-box-input',
  templateUrl: './chat-box-input.component.html',
})
export class ChatBoxInputComponent {
  @Output() sendText = new EventEmitter<string>();

  public form: FormGroup;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit() {
    this.initForm();
  }

  private initForm() {
    this.form = this.formBuilder.group({
      text: new FormControl(''),
    });
  }

  canValidate() {
    return !!this.form?.valid;
  }

  send() {
    const formValue = this.form.value;
    this.sendText.emit(formValue.text);
    this.form.reset();
  }
}
